import { Plane } from 'lucide-react';

import { TEXT } from '../theme/tokens';

// The source → destination separator: an airplane trailing three dots
// (FD-ADR-031, owner request 2026-08-11), replacing the plain arrow.
//
// The dots brighten toward the plane so the group reads as a contrail with a
// direction rather than as three decorative pips. Lucide's Plane points
// north-east, so `rotate-45` aims it along the row at the destination.
//
// `aria-label="to"` is what a screen reader announces between the two tenant
// labels — "contoso.com to fabrikam.com". An airplane read as "airplane" in the
// middle of a route would be noise.
export default function RouteFlight() {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-[3px] px-0.5"
      role="img"
      aria-label="to"
    >
      <span
        className="h-[3px] w-[3px] rounded-full opacity-40"
        style={{ backgroundColor: TEXT.disabled }}
      />
      <span
        className="h-[3px] w-[3px] rounded-full opacity-60"
        style={{ backgroundColor: TEXT.disabled }}
      />
      <span
        className="h-[3px] w-[3px] rounded-full opacity-90"
        style={{ backgroundColor: TEXT.disabled }}
      />
      <Plane
        size={13}
        strokeWidth={1.5}
        className="rotate-45"
        style={{ color: TEXT.secondary }}
      />
    </span>
  );
}
